/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Emails from './Emails/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Phones from './Phones/index'
import PracticeHub from './PracticeHub/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import Relationship from './Relationship/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let personValueData = fromData.useDataValue({ viewPath,
context: 'person',
})
let aggregateData = fromAggregate.basicPatientInformation(personValueData)
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="person"
 aggregate="/Data/aggregate.js basicPatientInformation"
 text={aggregateData}
 weight="medium"
 size="normal"
/>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
</div>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<PracticeHub
  viewPath={`${viewPath}/PracticeHub`}
/>
{children}
</React.Fragment>)
}